import { ApplicationRef, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ButtonComponent } from '../../ui/button/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { SafePipe } from '../../shared/pipes/safe/safe.pipe';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../../shared/components/base/base.component';
import { Store } from '@ngrx/store';
import { IAppState } from '../../ngrx';
import { NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';



@Component({
    selector: 'app-hero',
    templateUrl: './hero.component.html',
    imports: [
        ButtonComponent,
        TranslateModule,
        SafePipe,
        RouterLink,
        NgStyle,
        RouterLink,
    ],
    styleUrls: [
        './../website-grid.scss',
        './../website-pages.scss',
        './hero.component.scss',
        './../website-animations.scss'
    ]
})
export class HeroComponent extends BaseComponent implements OnInit {

  deviceType: string;
  currentLocale: string | number;

  constructor(
    private _store: Store<IAppState>,
    private cdr: ChangeDetectorRef,
    private appRef: ApplicationRef // Inject ApplicationRef
  ) {
    super();
  }

  ngOnInit(): void {
    this._store.select(s => s.ui.device).pipe(
        takeUntil(this.destroy$))
        .subscribe((device) => {
          this.deviceType = device.calculatedDeviceType;
        }
    );

    this._store.select(state => state.ui.locale).pipe(
      takeUntil(this.destroy$)
    ).subscribe(locale => {
      this.currentLocale = locale;
    });
  }

  titleFontSize() {
    if (this.currentLocale === 'no') {
      if (this.deviceType === 'mobile') {
        return '45px';
      }

      if (this.deviceType === 'tablet') {
        return '59px';
      }
    }
  }

}
